export default __webpack_public_path__ + "static/media/azure_icon.ce7113ff.png";